/**
 * Preset message templates. Replaces `chat-modal.js::PRESET_MESSAGES` and the
 * preset selection logic from `preset-messages.js`.
 *
 * Single source of truth for the canned messages users can send to a driver.
 * Each preset has an `id`, `label` (button text), and `body` (the actual text).
 */

/**
 * @typedef {Object} PresetMessage
 * @property {string} id
 * @property {string} label
 * @property {string} body
 * @property {string} [icon]
 */

/** @type {ReadonlyArray<PresetMessage>} */
export const PRESETS = Object.freeze([
  {
    id: 'blocking',
    icon: '🚗',
    label: 'אתה חוסם אותי',
    body: 'שלום, הרכב שלך חוסם אותי. אנא הזז אותו בהקדם, תודה.',
  },
  {
    id: 'lights-on',
    icon: '💡',
    label: 'השארת אורות',
    body: 'שלום, השארת את אורות הרכב דולקים. כדאי לכבות לפני שהמצבר ינוח.',
  },
  {
    id: 'window-open',
    icon: '🪟',
    label: 'חלון פתוח',
    body: 'שלום, חלון הרכב שלך נשאר פתוח. כדאי לסגור.',
  },
  {
    id: 'dent',
    icon: '🔧',
    label: 'מכה קלה',
    body: 'שלום, הייתה נגיעה קלה ברכב שלך. אנא חזור אליי לפרטים.',
  },
  {
    id: 'parking-ticket',
    icon: '🅿️',
    label: 'דוח חניה',
    body: 'שלום, ראיתי שמתחילים לחלק דוחות חניה ליד הרכב שלך.',
  },
]);

/**
 * @param {string} id
 * @returns {PresetMessage | null}
 */
export function findById(id) {
  return PRESETS.find((p) => p.id === id) ?? null;
}

/**
 * Append the sender's phone consent footer if they opted in to sharing.
 * Mirrors the legacy `phonePolicy: 'share'` text added to preset bodies.
 *
 * @param {string} body
 * @param {boolean} sharePhone
 * @param {string | null | undefined} senderPhone
 * @returns {string}
 */
export function withPhoneFooter(body, sharePhone, senderPhone) {
  if (!sharePhone || !senderPhone) return body;
  return `${body}\nלחזרה: ${senderPhone}`;
}
